<template>
  <nav class="app-navigation" role="navigation">
    <div class="container">
      <!-- Logo -->
      <Logo />

      <!-- Nav -->
      <ul id="navigation" :class="{ 'is-active': burgerOpen }">
        <li v-for="(link, key) in links" :key="key" class="roboto-condensed">
          <router-link
            :class="link.name"
            :to="$i18nRoute({ name: link.name })"
            v-on:click.native="handleClick"
          >
            <span>{{ $t(link.name) }}</span>
          </router-link>
        </li>

        <li class="roboto-condensed">
          <a
            class="forum-link"
            :class="{ disabled: forumLinkDisabled }"
            v-on:click.once="disableForumLink"
            :href="forumHref"
            ><span>{{ $t("forum") }}</span></a
          >
        </li>

        <li class="roboto-condensed">
          <a
            href="https://ninjatheory.zendesk.com/hc/en-gb/categories/360003013340-Bleeding-Edge-Support-Centre"
            ><span>{{ $t("support") }}</span></a
          >
        </li>

        <li v-if="!user.id" class="roboto-condensed">
          <a href="/login"
            ><span>{{ $t("login") }}</span></a
          >
        </li>

        <li
          class="roboto-condensed gamertag-info"
          v-if="user.id && user.picture"
        >
          <img :src="user.picture" :alt="user.username + ' gamerpic'" />
          <a href="javascript:void(0);">
            <span class="gamertag-name">{{ user.username }}</span>
          </a>
          <ul>
            <li>
              <a :href="forumUsername"
                ><span>{{ $t("profile") }}</span></a
              >
            </li>
            <li>
              <a href="/redeem-code"
                ><span>{{ $t("redeem_code") }}</span></a
              >
            </li>
            <li>
              <a href="/api/logout"
                ><span>{{ $t("logout") }}</span></a
              >
            </li>
          </ul>
        </li>

        <li class="roboto-condensed" v-if="user.id && !user.picture">
          <a href="/api/logout"
            ><span>{{ $t("logout") }}</span></a
          >
        </li>

        <li class="roboto-condensed mobile-user-options" v-if="user.id">
          <a :href="forumUsername"
            ><span>{{ $t("profile") }}</span></a
          >
        </li>
        <li class="roboto-condensed mobile-user-options" v-if="user.id">
          <a href="/redeem-code"
            ><span>{{ $t("redeem_code") }}</span></a
          >
        </li>
        <li class="roboto-condensed mobile-user-options" v-if="user.id">
          <a href="/api/logout"
            ><span>{{ $t("logout") }}</span></a
          >
        </li>
      </ul>

      <AppButton
        class="join-up-btn join-up-btn-small button button-red-small"
        type="router"
        cta="join_up"
        route="join_the_alpha"
      />

      <!-- Burger -->
      <button
        class="hamburger hamburger--spin"
        :class="{ 'is-active': burgerOpen }"
        type="button"
        aria-label="Menu"
        aria-controls="navigation"
        @click.prevent="toggleMenu"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>

    <AppButton
      class="join-up-btn join-up-btn-large button button-red-small"
      type="router"
      cta="join_up"
      route="join_the_alpha"
    />
  </nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import AppButton from "@/components/ui/AppButton";
import Logo from "@/components/ui/Logo";

export default {
  name: "AppNavigation",
  components: {
    Logo,
    AppButton
  },
  created() {
    this.$router.options.routes[0].children.forEach(route => {
      if (route.display === false) return;
      this.links.push({
        name: route.name,
        path: route.path
      });
    });
  },
  data() {
    return {
      links: [],
      burgerOpen: false,
      forumLinkDisabled: false,
      forumHref: "/forums"
    };
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    forumUsername() {
      let username = this.user.username;
      username = username.toLowerCase();
      username = username.replace(" ", "-");

      return "/forums/user/" + username;
    }
  },
  methods: {
    ...mapActions({
      // unsetUser: 'unsetUser'
    }),
    toggleMenu() {
      // toggle burger and body class
      if (this.burgerOpen) {
        // close
        this.closeMenu();
      } else {
        // open
        this.openMenu();
      }
    },
    openMenu() {
      // open
      this.burgerOpen = true;

      // add class
      document.querySelector("body").classList.add("modal-open");
    },
    closeMenu() {
      // close
      this.burgerOpen = false;

      // remove class
      document.querySelector("body").classList.remove("modal-open");
    },
    handleClick() {
      // if menu is open, close it when clicking link
      if (this.burgerOpen) {
        this.closeMenu();
      }
    },
    disableForumLink() {
      // redirect user if not clicked already
      if (!this.forumLinkDisabled) {
        window.location.href = this.forumHref;
      }

      // disable button & href
      this.forumLinkDisabled = true;
      this.forumHref = "javascript:void(0);";
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_hamburger.scss";

.forum-link {
  &.disabled {
    pointer-events: none;
    cursor: pointer;
  }
}

.app-navigation {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: sticky;
  top: 0;
  z-index: 20;

  @include bp($bp--m) {
    padding: 0;
  }

  .logo {
    z-index: 7;

    &:before {
      content: none;
    }
  }

  &:before {
    content: " ";
    display: block;
    width: 100%;

    position: absolute;
    z-index: 5;
    pointer-events: none;
    background: transparent url("~@/assets/images/nav-desktop-bg3.png")
      no-repeat top center;
    background-size: auto 78px;
    pointer-events: none;
    height: 70px;

    @include bp($bp--m) {
      height: 260px;
      z-index: 2;
      background-size: auto;
      background-position: top center;
      top: -30px;
    }

    @include bp($bp--xl) {
      top: 0;
    }
  }

  &:after {
    content: " ";
    display: none;
    width: 100%;
    position: absolute;
    z-index: 1;
    pointer-events: none;
    height: 50px;
    bottom: -35px;

    @include scrimGradient(#000);
    @include bp($bp--m) {
      height: 100px;
      bottom: -80px;
    }
  }

  .container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    top: 8px;

    @include bp($bp--m) {
      height: 110px;
      top: -10px;
    }

    @include bp($bp--xl) {
      top: 10px;
    }
  }

  ul {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 6;
    transition: transform 0.25s ease-in-out;
    transform: translate3d(100%, 0, 0);
    padding-top: 10%;
    background: transparent url("~@/assets/images/blue-mob.jpg") no-repeat top
      center;
    background-size: cover;
    // overflow-y: auto;
    display: flex;
    flex-direction: column;

    &.is-active {
      transform: translate3d(0%, 0, 0);
    }

    @include bp($bp--l) {
      display: block;
      // overflow-y: hidden;
      background: none;
      transition: none;
      transform: translate3d(0%, 0, 0);
      position: static;
      height: auto;
      display: flex;
      flex: 1;
      padding: 0;
      flex-direction: row;
      margin-top: -10px;
    }

    @include bp($bp--l) {
      max-width: 80%;
    }

    @include bp($bp--xl) {
      margin-top: -20px;
    }
  }

  li {
    font-size: 20px;
    margin: 20px auto;

    @include bp($bp--l) {
      text-transform: uppercase;
      font-weight: bold;
      margin: 8% auto;
      font-size: 16px;
      margin: 40px auto;
      margin-left: auto;
    }

    &.mobile-user-options {
      @include bp($bp--l) {
        display: none;
      }
    }

    &.gamertag-info {
      display: none;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 0;
      margin-bottom: 0;
      position: relative;

      @include bp($bp--l) {
        display: flex;
      }

      &:hover {
        ul {
          @include bp($bp--l) {
            display: flex;
          }
        }
      }

      a {
        position: relative;
      }

      ul {
        width: 300px;
        max-width: 140px;
        height: 110px;
        position: absolute;
        top: 0;
        left: 45px;
        flex-direction: column;
        display: none;
        transform: translate3d(0, 0, 0);
        margin: 0;
        background: $darkBlue;
        border-radius: 4px;

        @include bp($bp--l) {
          top: 75%;
        }

        li {
          font-size: 16px;
          margin: 0;
          padding: 0 10px;

          &:last-child {
            a {
              border-bottom: none;
              box-shadow: none;
            }
          }
        }

        a {
          width: 100%;
          color: #929eb7;
          padding: 10px 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.4);
          box-shadow: 0px 1px 0 0 rgba(255, 255, 255, 0.4);
          display: block;

          &:hover {
            span {
              color: #fff;
            }

            &:before {
              opacity: 0;
            }
          }
        }
      }

      img {
        width: 44px;
        height: 44px;
        border-radius: 100%;
        margin-right: 10px;
      }

      span {
        color: #929eb7;
      }
    }
  }

  a {
    text-decoration: none;
    position: relative;

    span {
      color: #929eb7;
      transition: color 0.25s ease-in-out;
    }

    &:before {
      width: 76px;
      height: 7px;
      content: "";
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.25s ease-in-out;

      background-image: url("~@/assets/images/nav-highlight.png");
      background-repeat: no-repeat;
      background-position: center bottom;
      background-size: cover;

      position: absolute;
      top: 100%;
      left: 50%;
      right: 0;
      transform: translate3d(-50%, 0, 0);
    }

    &:hover {
      span {
        color: #fff;
      }

      &:before {
        opacity: 1;
      }
    }

    &.router-link-exact-active {
      span {
        color: #fff;
      }

      &:before {
        opacity: 1;
      }
    }
  }

  .hamburger {
    padding: 10px 0;
    z-index: 6;
    margin-left: 20px;

    @include bp($bp--l) {
      display: none;
    }
  }

  .join-up-btn {
    width: 150px;
    height: 50px;
    position: relative;
    z-index: 5;

    &-small {
      margin-left: auto;
      margin-right: 0;

      @include bp($bp--xl) {
        margin-top: -20px;
      }

      @include bp($max-width) {
        display: none;
      }
    }

    &-large {
      display: none;

      @include bp($max-width) {
        display: flex;
        position: absolute;
        top: 50%;
        right: 20px;
        margin-top: -2px;
        transform: translate3d(0, -50%, 0);
      }
    }

    a,
    button {
      &:before {
        content: none;
      }

      span {
        color: inherit;
      }
    }
  }
}

// Add class to fighters, news
body.fighters .app-navigation li a.fighters,
body.news .app-navigation li a.news,
body.news-view .app-navigation li a.news {
  span {
    color: #fff;
  }

  &:before {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/AppNavigation.vue